export default __webpack_public_path__ + "assets/icons/warning.404883f0.svg";